export class OrganizationSectionFieldAliases {
  static ORGANIZATION_SUBJECT = 'organization_subject'
  static ORGANIZATION_NAME = 'organization_name'
  static ORGANIZATION_INN = 'organization_inn'
  static ORGANIZATION_ADDRESS = 'organization_address'
  static ORGANIZATION_PHONE = 'organization_phone'
  static ORGANIZATION_EMAIL = 'organization_email'
  static ORGANIZATION_WEBSITE = 'organization_website'
  static CONTRACT_NUMBER = 'contract_number'
  static CONTRACT_DATE_OF = 'contract_date_of'
  static CONTRACT_DATE_TO = 'contract_date_to'
  static CONTRACT_ORG_NAME = 'contract_org_name'
  static CONTRACT_ORG_INN = 'contract_org_inn'
}

export class PassSectionFieldAliases {
  static PASS_KIND = 'pass_kind'
  static ADDITIONAL_PURPOSE = 'additional_purpose'
  static TOP_CUSTOM_FIELDS = 'top_custom_fields'
  static BOTTOM_CUSTOM_FIELDS = 'bottom_custom_fields'
  static TIME_TO = 'time_to'
  static TIME_OF = 'time_of'
  static TIME_INTERVAL = 'time_interval'
  static PERIOD_TO = 'period_to'
  static PERIOD_OF = 'period_of'
  static TIME_TYPE = 'time_type'
  static TERMINAL_SUBDIVISION = 'terminal_subdivision'
  static TERMINAL_SUBDIVISION_TWO = 'terminal_subdivision_two'
  static AGENT_ORGANIZATION = 'agent_organization'
  static TERMINAL_SECTOR = 'terminal_sector'
  static APPLICATION_PURPOSE = 'application_purpose'
  static TERMINAL_ID = 'terminal_id'
  static VISITORS_CATEGORY = 'visitors_category'
  static PAYMENT_TYPE = 'payment_type'
}

export class VisitorSectionFieldAliases {
  static FULL_NAME = 'full_name'
  static LAST_NAME = 'last_name'
  static FIRST_NAME = 'first_name'
  static PATRONYMIC_NAME = 'patronymic_name'
  static BIRTHDAY = 'birthday'
  static PLACEBIRTH = 'placebirth'
  static NATIONALITY = 'nationality_id'
  static IDENTIFICATION_DOCUMENT = 'identification_id'
  static IDENTIFICATION_NUMBER = 'identification_number'
  static IDENTIFICATION_DATE_OF = 'identification_date_of'
  static IDENTIFICATION_DATE_TO = 'identification_date_to'
  static IDENTIFICATION_CODE = 'identification_code'
  static IDENTIFICATION_PLACE = 'identification_place'
  static ADDRESS = 'address'
  static SUBDIVISION_ID = 'subdivision_id'
  static PHONE = 'phone'
  static ACTUAL_ADDRESS = 'actual_address'
  static ORGANIZATION_NAME = 'organization_name'
  static ORGANIZATION_POSITION_FOR_TRANSPORT_PASS = 'status_for_transport_pass'
  static ORGANIZATION_POSITION = 'status'
  static ORGANIZATION_EMAIL = 'email'
}

export class TransportSectionFieldAliases {
  static TYPE_INPUT = 'type'
  static TYPE_FROM_STS_INPUT = 'type_from_sts'
  static NUMBER_PLATE = 'number'
  static NUMBER_PLATE_TRAILER = 'trailer'
  static MARK = 'mark'
  static MODEL = 'model'
  static COLOR = 'color'
  static OWNER = 'owner'
  static USER_POSITION = 'user_position'
}
